<!-- 创建实体 -->
<template>
    <div v-loading="loading">
        <div class="form-main">
            <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" class="formData">
                <div class="formData-top">
                    <div class="form-left form-column">
                        <el-form-item label="标签类型" prop="Tags">
                            <el-select filterable clearable allow-create v-model="formData.Tags" :disabled="isReadOnly">
                                <el-option v-for="optionItem in tagsList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户名称" prop="Name" v-if="source == 1">
                            <el-input v-model="formData.Name" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="供应商名称" prop="Name" v-else>
                            <el-input v-model="formData.Name" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="客户来源" v-if="source == 1">
                            <el-select filterable clearable allow-create v-model="formData.Source" :disabled="isReadOnly" style="width: 70%">
                                <el-option v-for="optionItem in sourceList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                            </el-select>
                            <el-button icon="el-icon-edit" type="text" style="margin-left: 5px" @click="showSourceDialog" v-if="!isReadOnly">编辑</el-button>
                        </el-form-item>
                        <el-form-item label="简称" v-else>
                            <el-input v-model="formData.Abbr" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号" prop="CallNum">
                            <el-input v-model="formData.CallNum" :maxlength="20" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="QQ">
                            <el-input v-model="formData.Qq" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-center form-column">
                        <el-form-item label="微信">
                            <el-input v-model="formData.WeChat" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="社媒号">
                            <el-input v-model="formData.Payment" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="电子邮箱">
                            <!-- prop="Email" -->
                            <el-input v-model="formData.Email" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="邮编">
                            <el-input v-model="formData.Zipcode" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="网址">
                            <el-input v-model="formData.Website" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-right form-column">
                        <!-- 主营配件名称，主营适用车型 必填 by qdl 2020/4/7 -->
                        <el-form-item label="主营配件" prop="MainPartName">
                            <el-input v-model="formData.MainPartName" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="主营车型" prop="MainVehicle">
                            <el-input v-model="formData.MainVehicle" placeholder="格式：品牌 + 车系" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="其他联系人">
                            <el-input v-model="formData.Contactor" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人电话" prop="PhoneNum">
                            <el-input v-model="formData.PhoneNum" :maxlength="20" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="职位">
                            <el-input v-model="formData.Position" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="formData-bottom">
                    <div>
                        <el-form-item label="国家" prop="CountryId">
                            <el-select
                                v-model="formData.Country"
                                style="width: 186px"
                                filterable
                                clearable
                                value-key="CountryName"
                                @change="countryChange"
                                placeholder="请选择"
                                :disabled="isReadOnly"
                            >
                                <el-option v-for="item in countryList" :key="item.CountryId" :label="item.CountryName" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item label="省市区">
                            <el-select
                                v-model="formData.Province"
                                style="width: 164px"
                                filterable
                                clearable
                                value-key="ProvinceName"
                                @change="provinceChange"
                                placeholder="请选择省"
                                :disabled="isReadOnly"
                            >
                                <el-option v-for="item in provinceList" :key="item.ProvinceId" :label="item.ProvinceName" :value="item"></el-option>
                            </el-select>
                            <el-select
                                v-model="formData.City"
                                style="width: 164px"
                                filterable
                                clearable
                                value-key="CityName"
                                @change="cityChange"
                                placeholder="请选择市"
                                :disabled="isReadOnly"
                            >
                                <el-option v-for="item in cityList" :key="item.CityId" :label="item.CityName" :value="item"></el-option>
                            </el-select>
                            <el-select
                                v-model="formData.Zone"
                                style="width: 164px"
                                filterable
                                clearable
                                value-key="DistrictName"
                                @change="zoneChange"
                                placeholder="请选择区"
                                :disabled="isReadOnly"
                            >
                                <el-option v-for="item in zoneList" :key="item.DistrictId" :label="item.DistrictName" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="formData-bottom">
                    <el-form-item label="详细地址">
                        <el-input v-model="formData.Address" style="width: 493px" maxlength="180" :disabled="isReadOnly"></el-input>
                    </el-form-item>
                    <img src="../../../assets/images/add.png" class="addicon" @click="addAddress()" title="添加地址" v-if="source == 1 && !isReadOnly" />
                    <el-form-item label="区号" label-width="94px">
                        <div class="form-value" style="width: 192px">
                            {{ formData.ZoneNum }}
                        </div>
                    </el-form-item>
                </div>
                <div class="formData-bottom" v-if="showSecAddr && source == 1">
                    <el-form-item label="地址2">
                        <el-input v-model="formData.Address2" style="width: 493px" maxlength="150" :disabled="isReadOnly"></el-input>
                    </el-form-item>
                    <img src="../../../assets/images/del.png" class="addicon" @click="delAddress(2)" v-if="!isReadOnly" />
                </div>
                <div class="formData-bottom" v-if="showThirdAddr && source == 1">
                    <el-form-item label="地址3">
                        <el-input v-model="formData.Address3" style="width: 493px" maxlength="150" :disabled="isReadOnly"></el-input>
                    </el-form-item>
                    <img src="../../../assets/images/del.png" class="addicon" @click="delAddress(3)" v-if="!isReadOnly" />
                </div>
                <div class="formData-bottom">
                    <el-form-item label="备注">
                        <el-input v-model="formData.Infoes" style="width: 507px" :disabled="isReadOnly"></el-input>
                    </el-form-item>
                    <el-form-item :label="source == 1 ? '跟进业务员' : '跟进采购员'">
                        <el-select v-model="formData.FollowerId" class="search-item" filterable placeholder="请选择" clearable :disabled="isReadOnly">
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialog-footer" v-if="!isReadOnly">
                <el-button class="btn-primary" @click="submitForm">提交</el-button>
                <el-button @click="cancel()">取消</el-button>
            </div>
        </div>

        <customerSource v-if="sourceVisible" :dialogFormVisible="sourceVisible" @closeSourceDialog="closeSourceDialog"></customerSource>
    </div>
</template>
<script>
import customerSource from '@/components/business/customerManage/customerSource';
export default {
    props: ['type', 'source', 'releEntpId'], // type 1 新增 2 编辑   source 1 客户 2 供应商
    components: {
        customerSource
    },
    name: '',
    data() {
        let checkEmail = this.$util.checkEmail;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: false,
            sourceVisible: false,
            isReadOnly: false,
            countryCode: '86',
            sourceList: [],
            countryList: [],
            provinceList: [],
            SIdList: [],
            cityList: [],
            zoneList: [],
            tagsList: [],
            showSecAddr: false,
            showThirdAddr: false,
            formData: {
                EntpCusId: '',
                Tags: '',
                Name: '',
                Abbr: '',
                Source: '',
                CallNum: '',
                Qq: '',
                WeChat: '',
                Payment: '',
                Email: '',
                Address: '',
                Address2: '',
                Address3: '',
                Zipcode: '',
                ZoneNum: '86',
                MainPartName: '',
                MainVehicle: '',
                Contactor: '',
                PhoneNum: '',
                Position: '',
                Infoes: '',
                Website: '',
                Country: {
                    CallCode: '86',
                    CountryId: '54416925-01EE-40A2-A536-DA142C06F5E8',
                    CountryName: '中国'
                },
                CountryId: '54416925-01EE-40A2-A536-DA142C06F5E8',
                Province: {},
                ProvinceId: '',
                City: {},
                CityId: '',
                Zone: {},
                ZoneId: '',
                FollowerId: userMsg.EmployeeId,
                CusType: 0
            },
            rules: {
                Name: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                CountryId: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                Tags: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                MainPartName: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                MainVehicle: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                CallNum: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                Email: [
                    {
                        validator: checkEmail,
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    mounted() {
        if (this.releEntpId) this.initPage();
        else this.$util.warningMsg('需要提取的企业信息异常，请刷新后重新操作');
    },
    methods: {
        async initPage() {
            this.loading = true;
            await this.searchTags();
            await this.getCountryList();
            await this.getSourceList();
            await this.getSIdList();
            await this.getProvinceList(this.formData.Country.CountryId);
            this.getCustomer();

            this.loading = false;
        },
        async getCustomer() {
            let res = await this.$util
                .axiosGet({
                    url: '/api/EntpUnions/GetEnterpriseData',
                    data: {
                        ReleEntpId: this.releEntpId
                    }
                })
                .catch(() => {});
            let data = res.data;
            this.formData = data;
            this.formData.EntpCusId = data.Id;
            this.formData.CusType = +this.source;
        },
        // 提交表单
        submitForm() {
            this.$refs.formData.validate(valid => {
                let that = this;
                if (valid) {
                    that.loading = true;
                    that.$util
                        .axiosPost({
                            url: '/api/EntpUnions/TranEnterpriseEntity',
                            data: that.formData,
                            hideLoading: true
                        })
                        .then(() => {
                            that.$util.successMsg('成功保存企业信息');
                            that.$emit('closeDialog', true);
                        })
                        .finally(() => {
                            that.loading = false;
                        });
                } else {
                    this.$util.errorMsg('校验不通过');
                    return false;
                }
            });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        showSourceDialog() {
            this.sourceVisible = true;
        },
        closeSourceDialog() {
            this.getSourceList();
            this.sourceVisible = false;
        },
        countryChange(value) {
            this.formData.CountryId = value.CountryId;
            this.countryCode = value.CallCode;
            this.formData.ZoneNum = value.CallCode;
            this.formData.ProvinceId = '';
            this.formData.Province = {};
            this.formData.CityId = '';
            this.formData.City = {};
            this.formData.ZoneId = '';
            this.formData.Zone = {};
            this.cityList = [];
            this.zoneList = [];
            this.getProvinceList(value.CountryId);
        },
        provinceChange(value) {
            this.formData.ProvinceId = value.ProvinceId;
            this.formData.CityId = '';
            this.formData.City = {};
            this.formData.ZoneId = '';
            this.formData.Zone = {};
            this.getCityList(value.ProvinceId);
        },
        cityChange(value) {
            let _CallCode = value.CallCode ? parseInt(value.CallCode).toString() : '';
            this.formData.CityId = value.CityId;
            this.formData.ZoneNum = this.countryCode + _CallCode;
            this.formData.ZoneId = '';
            this.formData.Zone = {};
            this.getZoneList(value.CityId);
        },
        zoneChange(value) {
            this.formData.ZoneId = value.DistrictId;
            this.formData.Zone = value.DistrictName;
        },
        getSourceList() {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpCustomers/GetEnterpriseCustomerSources',
                        hideLoading: true
                    })
                    .then(res => {
                        this.sourceList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getCountryList() {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetCountryList',
                        hideLoading: true
                    })
                    .then(res => {
                        this.countryList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getProvinceList(CountryId) {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetProvinceList',
                        data: {
                            CountryId: CountryId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.provinceList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getCityList(ProvinceId) {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetCityList',
                        data: {
                            ProvinceId: ProvinceId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.cityList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getZoneList(CityId) {
            this.$util
                .axiosGet({
                    url: '/api/Region/GetDistrictList',
                    data: {
                        CityId: CityId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.zoneList = res.data;
                })
                .catch(() => {});
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        searchTags() {
            let url = this.source == 1 ? '/api/EntpCustomers/GetEnterpriseCustomerTagList' : '/api/EntpSuppliers/GetEnterpriseSupplierTagList';
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: url,
                        hideLoading: true
                    })
                    .then(res => {
                        this.tagsList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        addAddress() {
            let that = this;
            if (that.formData.Address) {
                if (that.showSecAddr && !that.showThirdAddr) {
                    if (that.formData.Address2) that.showThirdAddr = true;
                    else this.$util.errorMsg('请先填写【地址2】，再进行添加【地址3】');
                } else if (that.showSecAddr && that.showThirdAddr) this.$util.errorMsg('目前仅支持新增3个地址');
                else that.showSecAddr = true;
            } else this.$util.errorMsg('请先填写【详细地址】，再进行添加【地址2】');
        },
        delAddress(idx) {
            let that = this;
            switch (idx) {
                case 2:
                    that.showSecAddr = false;
                    that.formData.Address2 = '';
                    break;
                case 3:
                    that.showThirdAddr = false;
                    that.formData.Address3 = '';
                    break;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.formData-bottom {
    display: flex;
}
.form-value {
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    color: #606266;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    width: 100%;
}
.form-column {
    width: 33.33%;
}
.formData-top {
    display: flex;
}
.dialog-footer {
    text-align: right;
}
.addicon {
    height: 30px;
    margin-left: 10px;
    margin-top: 5px;
}
</style>
